import { TNewOrderForm } from "@/entities/new-order";
import { CountriesSelect } from "@/features/countries-select";
import Hint from "@/shared/ui/hint";
import { Flex, Stack, Text } from "@mantine/core";
import { useMemo } from "react";
import { Controller, useFormContext } from "react-hook-form";
import styles from "./country-item.module.scss";
import { CountryTaskBlock } from "./country-task-block";

type TCountryItemProps = {
  countryIndex: number;
  remove: (index: number) => void;
  update: (
    index: number,
    value: TNewOrderForm["countriesList"][number],
  ) => void;
  append: (value: TNewOrderForm["countriesList"][number]) => void;
};

export const CountryItem = ({
  countryIndex,
  remove,
  update,
  append,
}: TCountryItemProps) => {
  const { control, watch } = useFormContext<TNewOrderForm>();

  const { countriesList, type } = watch();

  const country = countriesList[countryIndex];

  const isCountryDuplicate = useMemo(() => {
    return countriesList.some(
      (c, index) =>
        c.geo === country.geo &&
        index !== countryIndex &&
        c.geo !== null &&
        country.geo !== null,
    );
  }, [countriesList, country.geo, countryIndex]);

  return (
    <Stack w="100%" gap="md">
      <Flex align="center" gap="md">
        <Text w={135} ta="right">
          Country
        </Text>
        <Hint popupText="select the country of application promotion" />
        <Controller
          control={control}
          name={`countriesList.${countryIndex}.geo`}
          render={({ field }) => <CountriesSelect width={418} {...field} />}
        />
        {isCountryDuplicate ? (
          <Text className={styles.duplicate_error} c="secondary-red">
            This country is already exist
          </Text>
        ) : null}
      </Flex>
      {type ? (
        <CountryTaskBlock
          countryIndex={countryIndex}
          remove={remove}
          update={update}
          append={append}
        />
      ) : null}
    </Stack>
  );
};
